import { render, staticRenderFns } from "./flop-card-action.vue?vue&type=template&id=87e73ae6&"
import script from "./flop-card-action.vue?vue&type=script&lang=js&"
export * from "./flop-card-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports